(function () {
    var formApp = angular.module('formApp');
    formApp.controller('feedbackAssignmentHistoryController', ['$scope', '$http', 'DataServices', function ($scope, $http, DataServices) {
        $scope.getFeedbackAssignmentHistory = function () {
            $scope.feedbackAssignments = DataServices.responseInfo.feedbackAssignments;
        };
    }]);
}());